import OBJECTIVE_FORM_KEYS from 'apps/web/constants/forms/objective/formKeys';
import { Portal } from 'apps/web/enums/portal.enum';
import * as yup from 'yup';

import * as fields from './fields';
const ObjectiveSchema = (portal: Portal) => {
  const localSchema = {
    [OBJECTIVE_FORM_KEYS.subject]: fields.subject,
    [OBJECTIVE_FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [OBJECTIVE_FORM_KEYS.competency]: fields.competency,
    [OBJECTIVE_FORM_KEYS.language]: fields.language,
    [OBJECTIVE_FORM_KEYS.cognitiveVerbs]: fields.cognitiveVerbs,
    [OBJECTIVE_FORM_KEYS.affectiveVerbs]: fields.affectiveVerbs,
    [OBJECTIVE_FORM_KEYS.psychomotorVerbs]: fields.psychomotorVerbs,
  };

  const defaultSchema = {
    [OBJECTIVE_FORM_KEYS.subject]: fields.subject,
    [OBJECTIVE_FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [OBJECTIVE_FORM_KEYS.competency]: fields.competency,
    [OBJECTIVE_FORM_KEYS.cognitiveVerbs]: fields.cognitiveVerbs,
    [OBJECTIVE_FORM_KEYS.affectiveVerbs]: fields.affectiveVerbs,
    [OBJECTIVE_FORM_KEYS.psychomotorVerbs]: fields.psychomotorVerbs,
  };

  const americanSchema = {
    [OBJECTIVE_FORM_KEYS.curriculumFramework]: fields.curriculumFramework,
    [OBJECTIVE_FORM_KEYS.subject]: fields.subject,
    [OBJECTIVE_FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [OBJECTIVE_FORM_KEYS.specificStandards]: fields.specificStandards,
    [OBJECTIVE_FORM_KEYS.objectives]: fields.objectives,
  };

  switch (portal) {
    case Portal.PHILIPPINES:
      return yup.object().shape(localSchema);
    case Portal.USA:
      return yup.object().shape(americanSchema);
    default:
      return yup.object().shape(defaultSchema);
  }
};

export default ObjectiveSchema;
